import PropTypes from "prop-types";
import ALSkeleton from "./ALSkeleton";
import useResponsiveWithHydrationFix from "../../hooks/useResponsiveWithHydrationFix";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import useIsHydrationComplete from "../../hooks/useIsHydrationComplete";

function ALVideo({
  children,
  customClasses,
  previewOnly,
  videoThumbnailData,
  videoUrl = null,
  customAspectRatio = null,
  showControls = false,
}) {
  const isHydrationComplete = useIsHydrationComplete();
  let video = null;

  if (videoUrl) {
    video = <video src={videoUrl} autoPlay muted loop playsInline controls={showControls} />;
    if (previewOnly) {
      video = (
        <video src={videoUrl} autoPlay={false} muted loop playsInline controls={showControls} />
      );
    }
  }

  const videoContainer = <div className="video_content">{video}</div>;

  const aspectRatio = useResponsiveWithHydrationFix(
    `${videoThumbnailData?.mobile?.width} / ${videoThumbnailData?.mobile?.height}`,
    `${videoThumbnailData?.desktop?.width} / ${videoThumbnailData?.desktop?.height}`
  );

  let computedAspectRatio;

  if (customAspectRatio) {
    computedAspectRatio = customAspectRatio;
  } else if (videoThumbnailData?.hasData) {
    computedAspectRatio = aspectRatio;
  } else {
    computedAspectRatio = "inherit";
  }

  const style = {
    aspectRatio: computedAspectRatio,
  };

  return (
    <div className={`video_wrapper ${customClasses?.container || ""}`} style={style}>
      {children}
      {videoThumbnailData?.hasData ? (
        <>
          <img
            className={`${customClasses?.image_thumbnail || ""} video_container_thumbnail--desktop`}
            src={videoThumbnailData.desktop.url}
            alt="video thumbnail"
          />
          <img
            className={`${customClasses?.image_thumbnail || ""} video_container_thumbnail--mobile`}
            src={videoThumbnailData.mobile.url}
            alt="video thumbnail"
          />
        </>
      ) : (
        !isHydrationComplete && (
          <div
            className={`${customClasses?.skeleton_container || ""}`}
            style={{
              aspectRatio: videoThumbnailData?.hasData ? aspectRatio : "inherit",
            }}
          >
            <div
              className={`${customClasses?.skeleton_image || ""}`}
              style={{
                aspectRatio: videoThumbnailData?.hasData ? aspectRatio : "inherit",
              }}
            >
              <ALSkeleton />
            </div>
          </div>
        )
      )}
      <div className={customClasses?.video_container} />

      {isHydrationComplete && videoContainer}
    </div>
  );
}

ALVideo.propTypes = {
  children: PropTypes.node,
  customClasses: PropTypes.shape({
    container: PropTypes.string,
    image_thumbnail: PropTypes.string,
    video_container: PropTypes.string,
    video: PropTypes.string,
    skeleton_container: PropTypes.string,
    skeleton_image: PropTypes.string,
  }),
  previewOnly: PropTypes.bool,
  videoThumbnailData: PropTypes.shape({
    desktop: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    mobile: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    hasData: PropTypes.bool,
  }),
  videoUrl: PropTypes.string,
  customAspectRatio: PropTypes.string,
  showControls: PropTypes.bool,
};

export default withALErrorBoundary({ name: "ALVideo", priority: "P4" })(ALVideo);
